// --------------------------------------------------------------
// Created On: 2024-03-11
// Author: Zachary Thomas
//
// Last Modified: 2025-01-03
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants that describe reducer actions.
export const ROLE_TYPES = {
  SET_ROLES: "SET_ROLES",
  CREATE_ROLE: "CREATE_ROLE",
  UPDATE_ROLE: "UPDATE_ROLE",
  DELETE_ROLE: "DELETE_ROLE",
};
export const USER_TYPES = {
  SET_USERS: "SET_USERS",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  CREATE_USER: "CREATE_USER",
};
export const USERGROUP_TYPES = {
  SET_USERGROUPS: "SET_USERGROUPS",
  CREATE_USERGROUP: "CREATE_USERGROUP",
  UPDATE_USERGROUP: "UPDATE_USERGROUP",
  DELETE_USERGROUP: "DELETE_USERGROUP",
};
export const COMPANY_TYPES = {
  SET_COMPANIES: "SET_COMPANIES",
  CREATE_COMPANY: "CREATE_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  DELETE_COMPANY: "DELETE_COMPANY",
};
